$(document).on('click', '.toggle-faq:not(.disable-toggle)', function() {
    const title = $(this);
    // hide next element
    if(title.hasClass('active')){
        title.next().slideUp();
    }else{
        title.next().slideDown();
    }
    title.toggleClass('active');
    // check if this is a category or a question to toggle
    if(title.hasClass('faq__cats__questions__title')){
        // if not current clicked element, remove active class
        $('.faq__cats__questions__title:not(.disable-toggle)').not ($(this) ).removeClass('active').next().slideUp();
    }else{
        // if not current clicked element, remove active class
        $('.faq__cats__title:not(.disable-toggle)').not ($(this) ).removeClass('active').next().slideUp();
    }
});
